<template>
    <div class="apprentice-simple-card">
        <v-server-table
            ref="table"
            :url="url"
            :columns="columns"
            :options="options"
            name="accounts-table">
            <div
                slot="actions"
                slot-scope="{ row }">
                <div class="actions">
                    <b-button
                        class="btn-show btn-show-accounts"
                        variant="primary-icon-only"
                        @click="onSelect(row.id)"
                        :v-b-tooltip="$t('user_account.taking_over_account')"></b-button>

                    <b-button
                        class="btn-settings btn-settings-accounts"
                        v-b-modal="'accounts-update-user-modal' + row.id"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('common.edit')"></b-button>

                    <design-2021-accounts-index-update-user-modal-component
                        :user="row"></design-2021-accounts-index-update-user-modal-component>

                    <b-button
                        class="btn-school btn-school-accounts"
                        v-if="isCurrentSchool(row.userable_id)"
                        variant="primary-icon-only"
                        @click="onSelectSchool(row.userable_id)"
                        :v-b-tooltip="$t('user_account.taking_over_school')"></b-button>

                    <b-button
                        class="btn-remove btn-remove-accounts"
                        v-b-tooltip="$t('common.delete')"
                        variant="danger-icon-only"
                        @click="onRemove(row.id)"></b-button>
                </div>
            </div>
        </v-server-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-accounts-index-component',
    props: ['hideschool', 'schoolId'],
    data() {
        return {
            columns: ['full_name', 'email', 'userable_id', 'type_name', 'actions'],
            options: {
                sortIcon: {
                    base: 'fad',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down',
                },
                sortable: ['full_name', 'email', 'userable_id', 'type_name'],
                headings: {
                    full_name: this.$t('common.name'),
                    email: 'E-mail',
                    userable_id: 'School',
                    type_name: 'Type',
                    actions: this.$t('common.actions'),
                },
                saveState: true,
                requestFunction(data) {
                    if (data.orderBy) {
                        switch (data.orderBy) {
                            case 'type_name':
                                data.orderBy = 'type';
                                break;
                            case 'full_name':
                                data.orderBy = 'surname';
                                break;
                        }
                    }
                    return this.axios.get(this.url, { params: data }); //
                },
            },
            url: this.routes.accountsGetAll(),
        };
    },
    methods: {
        onRemove(id) {
            this.alert.confirm(this.$t('user_account.are_you_sure_you_want_to_delete_your_account')).then((confirm) => {
                if (confirm) {
                    this.alert.saving();

                    this.axios.delete(this.routes.schoolAccountUserDelete(id)).then(
                        (response) => {
                            this.updateTable();

                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                }
            });
        },

        onSelectSchool(id) {
            window.location.href = baseUrl + '/school/select/' + id;
        },

        onSelect(id) {
            window.location.href = baseUrl + '/school/select/user/' + id;
        },

        isCurrentSchool(school_id) {
            if (this.schoolId !== school_id) {
                return true;
            }

            return false;
        },
        sortCompare(firstRow, secondRow, key) {
            if (key == 'full_name' && firstRow[key] && secondRow[key]) {
                const firstName = String(firstRow.surname).toLowerCase();
                const secondName = String(secondRow.surname).toLowerCase();

                return firstName < secondName ? -1 : firstName > secondName ? 1 : 0;
            } else {
                return false;
            }
        },
    },
    mounted() {
        if (this.hideschool) {
            const tableRef = this.$refs.table;
            tableRef.toggleColumn('userable_id');
        }
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .btn {
        font-size: 1.125rem;
        align-self: center;

        &:before {
            margin-right: 0;
        }

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .btn-edit-roadmap:before {
        margin-right: 0;
    }
}
</style>
